import Api from './../service/Api';

export default {
  find: id => Api.get(`aulasteorica/getAula/${id}`),
  findAll: cpf => Api.get(`aulasteorica/${cpf}`),
  getMomento: (idAula, idAluno) => Api.post('aulasteorica/getMomento', { idAula, idAluno }).then(result => result),
  getTempoAula: (idAula) => Api.post('aulasteorica/getTempoRestante', { idAula }),
  getTimeFromBegin: (idAula) => Api.post('aulasteorica/getTimeFromBegin', { idAula }).then(response => response),
  getFake: (idAula) => Api.post('aulasteorica/fake', { idAula }).then(result => result),
  getNumeroBiometriasTiradas: (idAula, idAluno, momento) => Api.post('aulasteorica/getNumeroBiometriasTiradas', { idAula, idAluno, momento }),
  setCamImage: (image, name, classId, studentId, validation, metodo_prova_vida, momento, hash) => Api.post('aulasteorica/saveBiometria', {
    base64: image,
    name: name,
    aula_id: classId,
    aluno_id: studentId,
    verified: validation,
    metodo_prova_vida: metodo_prova_vida,
    momento: momento,
    hash:hash
  }),
  salvarHashMa: (idAula, cpf, hash, momento) => Api.post(`aulasteorica/salvarHashMa`, { idAula, cpf, hash, momento }),
  getJitsiParameters: (id, cpf) => Api.get(`aulasteorica/${id}/alunoJitsiParameters/${cpf}`)
};
